const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_MAX_LENGTH = 20;

const getCharacterTypeCount = password => {
	const hasNumber = /\d/.test(password);
	const hasUppercase = /[A-Z]/.test(password);
	const hasLowercase = /[a-z]/.test(password);
	const hasSymbol = /[^a-zA-Z0-9]/.test(password);

	return [hasNumber, hasUppercase, hasLowercase, hasSymbol].filter(Boolean).length;
};

const validatePassword = (password, context = {}) => {
	const value = String(password || '');
	const loginName = String(context.loginName || '');
	const phone = String(context.phone || '');

	if (value.length < PASSWORD_MIN_LENGTH) {
		return { valid: false, error: 'PASSWORD_TOO_SHORT' };
	}
	if (value.length > PASSWORD_MAX_LENGTH) {
		return { valid: false, error: 'PASSWORD_TOO_LONG' };
	}
	if (getCharacterTypeCount(value) < 2) {
		return { valid: false, error: 'PASSWORD_CATEGORY_TOO_FEW' };
	}
	if (loginName && value.toLowerCase().includes(loginName.toLowerCase())) {
		return { valid: false, error: 'PASSWORD_CONTAINS_LOGIN_NAME' };
	}
	if (phone && value.includes(phone)) {
		return { valid: false, error: 'PASSWORD_CONTAINS_PHONE' };
	}
	if (/(.)\1{2,}/.test(value)) {
		return { valid: false, error: 'PASSWORD_HAS_REPEATED_CHARACTER' };
	}
	if (/(.{2,})\1+/.test(value)) {
		return { valid: false, error: 'PASSWORD_HAS_REPEATED_FRAGMENT' };
	}

	return { valid: true };
};
// 强度检测
const getPasswordStrength = (password, context = {}) => {
	if (!validatePassword(password, context).valid) {
		return 'weak';
	}

	return password.length >= 12 && getCharacterTypeCount(password) >= 3 ? 'strong' : 'medium';
};
// 是否强制修改密码
const shouldShowPasswordSetup = (customer = {}) => {
	return Number(customer.needChangePwd) === 1;
};

export {
	PASSWORD_MAX_LENGTH,
	PASSWORD_MIN_LENGTH,
	getPasswordStrength,
	validatePassword,
	shouldShowPasswordSetup
};
